<app-instruction-icon />
Drag elements to craft
